/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M20 10.8H6.7l4.1-4.5-1.1-1.1-5.8 6.3 5.8 5.8 1.1-1.1-4-3.9H20z" />
	</SVG>
);

export default arrowLeft;
